export const fontFamily = {
  medium: "'Montserrat Medium', sans-serif",
  light: "'Montserrat Light', sans-serif",
  bold: "'Montserrat Bold', sans-serif",
  black: "'Montserrat Black', sans-serif"
}